// extracted by mini-css-extract-plugin
module.exports = {"constrainedWidth":"style-module__constrainedWidth___1Rnto"};